export default class ArgumentError extends TypeError {}
